import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { HelpArticlesCard } from "@faire/help-center-self-serve/components/HelpArticlesCard";
import { useFaireDirectWidgetChat } from "@faire/help-center-self-serve/hooks/useFaireDirectWidgetChat";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getRetailerOrBrandToken } from "@faire/help-center-utils/serialized-data/getRetailerOrBrandToken";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { useUserPerceivedLoadTimingWithKey } from "@faire/web--source/common/performance/userPerceivedLoadTiming/useUserPerceivedLoadTiming";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { trackCxFoundationsAnswerPageView } from "@faire/web-api--source/events/cxFoundations/view/answerPage";
import { QueryParameters as recommendedArticleParams } from "@faire/web-api--source/routes/support/self-serve/recommended-article";
import React, { Suspense, useEffect } from "react";
import { BackButton } from "../../components/BackButton";
import { CenteredLoadingSpinner } from "../../components/CenteredLoadingSpinner";
import { ComprehensiveCSATCollection } from "../../components/ComprehensiveCSATCollection";
import { InstantAnswerCard } from "../../components/InstantAnswerCard";
import { LazyMessageModal } from "../../components/Modals/MessageModal/LazyMessageModal";
import { LazyPayoutModal } from "../../components/Modals/PayoutModal/LazyPayoutModal";
import { useInstantAnswerContextAdditionalData } from "../../hooks/useInstantAnswerContextAdditionalData";
import { useIssueType } from "../../hooks/useIssueType";
import { useOrderToken } from "../../hooks/useOrderToken";
import { useScrollToTopOnLoadEffect } from "../../hooks/useScrollToTopEffect";
import { useSelectedBrandOrder } from "../../hooks/useSelectedBrandOrder";
import { useSelectedNodeAnswer } from "../../hooks/useSelectedNodeAnswer";
import { ContactOptions } from "./ContactOptions";
import { NoInstantAnswerSection } from "./NoInstantAnswerSection";
var PAGE_JS_EXECUTED_MARK = markPageJsExecuted();
export var Answer = function Answer() {
  useScrollToTopOnLoadEffect();
  useFaireDirectWidgetChat();
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    lastVisitedArticle = _useState2[0],
    setLastVisitedArticle = _useState2[1];
  var _useIssueType = useIssueType(),
    issueType = _useIssueType.issueType;
  var _useOrderToken = useOrderToken(),
    orderToken = _useOrderToken.orderToken;
  var _useSelectedBrandOrde = useSelectedBrandOrder(),
    selectedBrandOrder = _useSelectedBrandOrde.selectedBrandOrder;
  var _useSelectedNodeAnswe = useSelectedNodeAnswer(),
    hasInstantAnswer = _useSelectedNodeAnswe.hasInstantAnswer,
    instantAnswer = _useSelectedNodeAnswe.instantAnswer,
    hasHelpArticles = _useSelectedNodeAnswe.hasHelpArticles,
    helpArticles = _useSelectedNodeAnswe.helpArticles;
  var _useInstantAnswerCont = useInstantAnswerContextAdditionalData(instantAnswer),
    instantAnswerContextAdditionalData = _useInstantAnswerCont.instantAnswerContextAdditionalData,
    asyncDataComplete = _useInstantAnswerCont.asyncDataComplete;
  var retailer = getRetailer();
  var brand = getBrand();
  var retailerOrBrandToken = getRetailerOrBrandToken();
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var _useQueryParams = useQueryParams(recommendedArticleParams.parse),
    message_modal = _useQueryParams.message_modal,
    payout_update_modal = _useQueryParams.payout_update_modal;
  var loadTimingRef = useUserPerceivedLoadTimingWithKey({
    name: "help_center-page_self_serve_answer",
    numComponents: instantAnswer ? 3 : 2,
    enableTrackPerformanceBreakdown: "internal-tracking",
    pageLoadKey: "help_center-page_self_serve_answer",
    isPageLoading: false,
    pageJsExecutedMark: PAGE_JS_EXECUTED_MARK
  });
  useEffect(function () {
    trackCxFoundationsAnswerPageView(retailerOrBrandToken, issueType);
  }, [retailerOrBrandToken, issueType]);
  if (!asyncDataComplete) {
    return /*#__PURE__*/React.createElement(CenteredLoadingSpinner, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    "data-test-id": "answer-wrapper"
  }, /*#__PURE__*/React.createElement(BackButton, null), isMobile ? null : /*#__PURE__*/React.createElement(Spacer, {
    height: "4x"
  }), instantAnswer ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InstantAnswerCard, _objectSpread(_objectSpread({
    instantAnswer: instantAnswer,
    viewHasHelpCenterArticles: hasHelpArticles,
    brandOrder: selectedBrandOrder,
    brand: brand,
    retailer: retailer,
    issueType: issueType
  }, instantAnswerContextAdditionalData), {}, {
    loadTimingRef: loadTimingRef
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }))) : null, !hasInstantAnswer && hasHelpArticles ? /*#__PURE__*/React.createElement(NoInstantAnswerSection, null) : null, hasHelpArticles ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HelpArticlesCard, {
    visibleWhen: hasHelpArticles,
    articles: helpArticles,
    viewHasInstantAnswer: hasInstantAnswer,
    onClickOnArticle: setLastVisitedArticle,
    loadTimingRef: loadTimingRef
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }))) : null, hasInstantAnswer || hasHelpArticles ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ComprehensiveCSATCollection, {
    visibleWhen: hasInstantAnswer || hasHelpArticles,
    issue: issueType,
    brandOrRetailerToken: getRetailerOrBrandToken(),
    isInstantAnswerAvailable: hasInstantAnswer,
    suggestedArticles: helpArticles.map(function (_ref) {
      var id = _ref.id;
      return id;
    }),
    lastVisitedArticle: lastVisitedArticle,
    brandOrderToken: orderToken
  }), isMobile ? /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }) : /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }))) : null, /*#__PURE__*/React.createElement(ContactOptions, {
    loadTimingRef: loadTimingRef,
    hasDescription: !hasInstantAnswer && !hasHelpArticles
  }), message_modal === "1" ? (/*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazyMessageModal, _objectSpread({
    brandOrder: selectedBrandOrder,
    brand: brand,
    retailer: retailer
  }, instantAnswerContextAdditionalData)))) : null, payout_update_modal === "1" ? (/*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(LazyPayoutModal, _objectSpread({
    brandOrder: selectedBrandOrder,
    brand: brand,
    retailer: retailer
  }, instantAnswerContextAdditionalData)))) : null);
};